export default __webpack_public_path__ + "static/media/char_body_prem_008.c6dd289d.png";